import React from "react";

type AssistantSpeechIndicatorProps = {
  isSpeaking: boolean;
};

const AssistantSpeechIndicator = ({ isSpeaking }: AssistantSpeechIndicatorProps) => {
  return (
    <div className="flex items-center mb-2.5">
      <div className={`w-5 h-5 mr-2.5 rounded-sm ${isSpeaking ? "bg-green-400" : "bg-red-500"}`} />
      <p className="text-foreground m-0">
        {isSpeaking ? "Assistant speaking" : "Speak into the mic now!"}
      </p>
    </div>
  );
};

export default AssistantSpeechIndicator;
